<script type="text/babel">
  import Base from './BaseMultidimentionalChart.vue'

  export default Base.extend({
    name: "BarChart",
    methods: {
      getChartType: function () {
        return "bar";
      }
    }
  })
</script>



// WEBPACK FOOTER //
// BarChart.vue?6d9bbff8